import { Trophy } from "lucide-react";

export default function AnnouncementBanner() {
  return (
    <div 
      className="bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-600 py-2 px-4"
      data-testid="announcement-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
        <Trophy className="w-4 h-4 text-black flex-shrink-0" />
        <p className="font-mono text-black text-sm font-semibold text-center">
          <span className="font-bold">Inductees of the WWE Hall of Fame Class of 2026</span>
        </p>
        <Trophy className="w-4 h-4 text-black flex-shrink-0 hidden sm:block" />
      </div>
    </div>
  );
}
